/**
 * 会员套餐 SKU：GET /vip-skus
 */

import api from '@/utils/api'

const CHART_BY_INDEX = [
  {
    chartStroke: true,
    chartPath: 'M14,72 C46,63 72,52 103,42',
    chartDots: [
      { x: 14, y: 72, r: 3.4 },
      { x: 103, y: 42, r: 4.5 }
    ],
    chartGradient: ['#6ee7b7', '#065f46']
  },
  {
    chartStroke: true,
    chartPath: 'M12,74 C56,62 108,48 158,36 C198,26 238,18 272,12',
    chartDots: [
      { x: 12, y: 74, r: 3.2 },
      { x: 158, y: 36, r: 3.9 },
      { x: 272, y: 12, r: 4.7 }
    ],
    chartGradient: ['#fdba74', '#9a3412']
  },
  {
    chartStroke: true,
    chartPath: 'M10,76 C52,65 82,60 108,52 C142,42 188,32 228,22 C242,18 254,14 266,11',
    chartDots: [
      { x: 10, y: 76, r: 3.1 },
      { x: 108, y: 52, r: 3.5 },
      { x: 228, y: 22, r: 3.8 },
      { x: 266, y: 11, r: 4.9 }
    ],
    chartGradient: ['#fca5a5', '#7f1d1d']
  }
]

const THEMES = ['green', 'orange', 'red']

const DEFAULT_MODEL_ROWS = [
  // { label: '大语言模型', value: '无限免费' },
  // { label: '图生成模型', value: '5-25 积分/张', sub: '包含 Nano Banana 2 / GPT Image 2' },
  // {
  //   label: '视频模型(720P/1080P)',
  //   value: '5-40 积分/秒',
  //   sub: '包含 Kling 3.0 / Vidu Q3 Pro / Happy Horse 1.0 / Veo 3.1',
  //   sub2: '包含 Seedance 2.0',
  //   sota: true
  // },
  // { label: '音乐/旁白', value: '5 积分/生成' }
]

export const FREE_PLAN = {
  id: 'free',
  theme: 'neutral',
  badge: 'Free',
  name: '探索体验',
  icon: 'fas fa-seedling',
  playIcon: false,
  discountChip: null,
  chartStroke: false,
  chartPath: '',
  chartGradient: [],
  billingDays: 0,
  priceMain: '0',
  priceOld: null,
  monthlyCredits: '0',
  creditsBonus: null,
  cta: '开始使用',
  subsidy: ['每天邀请好友获得积分'],
  // modelRows: [
  //   { label: '大语言模型', value: '5 积分/对话' },
  //   { label: '图生成模型', value: '5-14 积分/张', sub: '包含 Nano Banana 2 / GPT Image 2' },
  //   { label: '视频模型(720P)', value: '5-15 积分/秒', sub: '包含 Kling 3.0 / Vidu Q3 Pro / Happy Horse 1.0 / Veo 3.1-Fast' },
  //   { label: '音乐/旁白', value: '5 积分/生成' }
  // ],
  usage: [
    { text: '单模型并发：3' },
    { text: '元素库容量：5 个元素' },
    { text: '去水印导出' },
    { text: '商用授权' }
  ],
  sku: null
}

function unwrapList(res) {
  if (res == null) return []
  if (Array.isArray(res)) return res
  if (Array.isArray(res.list)) return res.list
  const d = res.data
  if (Array.isArray(d)) return d
  if (d && typeof d === 'object') {
    if (Array.isArray(d.list)) return d.list
    if (Array.isArray(d.data)) return d.data
    if (d.data && typeof d.data === 'object' && Array.isArray(d.data.list)) return d.data.list
  }
  return []
}

function assertApiOk(res) {
  if (res == null || typeof res !== 'object') return
  const c = res.code
  if (c === undefined || c === null) return
  const n = Number(c)
  if (n === 0 || n === 200) return
  const msg = res.message || res.msg || res.error || `接口 code=${c}`
  throw new Error(msg)
}

/** 接口 money_price 为分；huaxian_money_price 为元 */
function priceYuanFromCents(cents) {
  const n = Number(cents)
  if (!Number.isFinite(n)) return '0'
  if (n <= 0) return '0'
  if (n >= 100) return String(Math.round(n / 100))
  return String(Math.round(n))
}

function priceYuanFromYuanField(yuan) {
  const n = Number(yuan)
  if (!Number.isFinite(n) || n <= 0) return null
  return String(Math.round(n))
}

function quanyitipsToUsage(quanyitips) {
  if (!Array.isArray(quanyitips)) return []
  return quanyitips
    .map(t => {
      const text = t && (t.text || t.title || t.label)
      return text ? { text: String(text).trim() } : null
    })
    .filter(Boolean)
}

/**
 * @param {object} sku
 * @param {number} paidIndex 付费档序号（0 起）
 */
export function mapVipSkuToPlan(sku, paidIndex) {
  const theme = THEMES[Math.min(paidIndex, THEMES.length - 1)] || 'orange'
  const chart = CHART_BY_INDEX[Math.min(paidIndex, CHART_BY_INDEX.length - 1)] || CHART_BY_INDEX[0]
  const days = Number(sku.days) || 30
  const priceMain = priceYuanFromCents(sku.discount_money_price ?? sku.money_price)
  let priceOld = priceYuanFromYuanField(sku.huaxian_money_price)
  if (priceOld && priceOld === priceMain) priceOld = null
  const credits = sku.reward_scores != null ? String(sku.reward_scores) : '0'
  const title = String(sku.title || '会员套餐').trim()
  const badge = String(sku.nicheng || sku.viplevel || title).trim()
  const usage = quanyitipsToUsage(sku.quanyitips)
  const subsidy = []
  if (sku.order_reward) subsidy.push(String(sku.order_reward))
  if (days >= 300) {
    subsidy.push(`有效期 ${Math.round(days / 365)} 年`)
  } else if (days > 0) {
    subsidy.push(`有效期 ${days} 天`)
  }

  return {
    id: `sku-${sku.id}`,
    skuUuid: sku.uuid || '',
    skuId: sku.id,
    theme,
    badge,
    name: title,
    icon: 'fas fa-bolt',
    playIcon: true,
    discountChip: sku.hottitle ? String(sku.hottitle) : null,
    billingDays: days,
    ...chart,
    priceMain,
    priceOld,
    monthlyCredits: credits,
    creditsBonus: days < 300 && credits !== '0' ? `(含 ${credits} 积分)` : null,
    creditsYearMorePct: null,
    cta: '升级',
    subsidy: subsidy.length ? subsidy : ['会员专属权益'],
    modelRows: DEFAULT_MODEL_ROWS,
    usage: usage.length ? usage : [{ text: '详见套餐权益说明' }],
    thumb: sku.thumb || null,
    sku
  }
}

export function buildPlansFromVipSkus(skus) {
  const list = Array.isArray(skus) ? skus.filter(s => s && Number(s.status) !== 0) : []
  list.sort((a, b) => {
    const wa = Number(a.list_weight) || 0
    const wb = Number(b.list_weight) || 0
    if (wb !== wa) return wb - wa
    const xa = Number(a.xingzhi) || 0
    const xb = Number(b.xingzhi) || 0
    if (xa !== xb) return xa - xb
    return (Number(a.money_price) || 0) - (Number(b.money_price) || 0)
  })
  const paid = list.map((sku, i) => mapVipSkuToPlan(sku, i))
  // return [FREE_PLAN, ...paid]
  return [...paid]
}

export function skuListHasYearly(skus) {
  return (Array.isArray(skus) ? skus : []).some(s => (Number(s.days) || 0) >= 300)
}

export async function fetchVipSkuList(opts = {}) {
  const params = {
    page: opts.page ?? 1,
    limit: opts.limit ?? 50,
    _t: Date.now(),
    ...(opts.xingzhi != null ? { xingzhi: opts.xingzhi } : {})
  }
  const res = await api.get('/vip-skus', { params })
  assertApiOk(res)
  return unwrapList(res)
}

export async function fetchVipPlans() {
  const skus = await fetchVipSkuList()
  return {
    skus,
    plans: buildPlansFromVipSkus(skus),
    hasYearly: skuListHasYearly(skus)
  }
}

function unwrapData(res) {
  if (res == null) return null
  if (res.data != null && typeof res.data === 'object' && !Array.isArray(res.data)) {
    return res.data
  }
  return res
}

/** 解包下单结果（兼容 data.data.order 双层嵌套） */
export function unwrapOrderPayload(res) {
  let d = unwrapData(res)
  for (let i = 0; i < 5; i++) {
    if (!d || typeof d !== 'object' || Array.isArray(d)) break
    if (d.order || d.pay_config || d.payConfig || d.payment_record || d.paymentRecord) break
    if (d.data != null && typeof d.data === 'object' && !Array.isArray(d.data)) {
      d = d.data
      continue
    }
    break
  }
  return d && typeof d === 'object' ? d : {}
}

function parseMaybeJsonObject(raw) {
  if (raw == null) return null
  if (typeof raw === 'object') return raw
  const s = String(raw).trim()
  if (!s) return null
  if (s.startsWith('{') || s.startsWith('[')) {
    try {
      return JSON.parse(s)
    } catch {
      return null
    }
  }
  return null
}

function pickPayQrCodeString(source, depth = 0) {
  if (depth > 10 || source == null) return ''
  if (typeof source === 'string') {
    const s = source.trim()
    if (!s) return ''
    const parsed = parseMaybeJsonObject(s)
    if (parsed) return pickPayQrCodeString(parsed, depth + 1)
    if (s.startsWith('alipays://') || /^https?:\/\//i.test(s)) return s
    if (s.length > 12 && !s.includes('<')) return s
    return ''
  }
  if (typeof source !== 'object') return ''
  const keys = ['qr_code', 'qrcode', 'qrCode', 'code_url', 'codeUrl', 'pay_string', 'payString']
  for (let i = 0; i < keys.length; i++) {
    const v = source[keys[i]]
    if (typeof v === 'string' && v.trim()) return v.trim()
  }
  const nestedKeys = [
    'pay_config',
    'payConfig',
    'data',
    'order',
    'payment_record',
    'paymentRecord',
    'alipay_trade_precreate_response'
  ]
  for (let i = 0; i < nestedKeys.length; i++) {
    const k = nestedKeys[i]
    if (source[k] != null) {
      const hit = pickPayQrCodeString(source[k], depth + 1)
      if (hit) return hit
    }
  }
  if (Array.isArray(source)) {
    for (let i = 0; i < source.length; i++) {
      const hit = pickPayQrCodeString(source[i], depth + 1)
      if (hit) return hit
    }
  }
  return ''
}

/**
 * 提交会员订单 POST /vip-orders
 * @param {{ skuId: number|string, couponId?: number|string|null }} opts
 */
export async function createVipOrder(opts = {}) {
  const skuId = Number(opts.skuId)
  if (!Number.isFinite(skuId) || skuId <= 0) {
    throw new Error('请选择有效的会员套餐')
  }
  const body = {
    sku_id: skuId,
    payment_method: 'alipay',
    paymentMethod: 'alipay',
    pay_type: 'alipay'
  }
  const couponId = opts.couponId
  if (couponId != null && couponId !== '' && couponId !== false) {
    body.coupon_id = couponId
  }
  const res = await api.post('/vip-orders', body)
  assertApiOk(res)
  return unwrapOrderPayload(res)
}

function centsToYuanDisplay(cents) {
  const n = Number(cents)
  if (!Number.isFinite(n)) return null
  if (n <= 0) return '0'
  if (n >= 100) return String(Math.round(n / 100))
  return String(Math.round(n))
}

/**
 * 统一 vip-orders 返回：订单常在 order 子对象，pay_config 可能在根级
 * @returns {{ root: object, order: object|null, payConfig: object }}
 */
function normalizeVipOrderResponse(orderRes) {
  const root = orderRes || {}
  const inner =
    root.order && typeof root.order === 'object' && !Array.isArray(root.order) ? root.order : null
  const pr = root.payment_record || root.paymentRecord || (inner && (inner.payment_record || inner.paymentRecord)) || {}
  let payConfig =
    root.pay_config ||
    root.payConfig ||
    (inner && (inner.pay_config || inner.payConfig)) ||
    (pr && (pr.pay_config || pr.payConfig)) ||
    {}
  if (typeof payConfig === 'string') {
    payConfig = parseMaybeJsonObject(payConfig) || { qr_code: payConfig }
  }
  return { root, order: inner, payConfig, paymentRecord: pr }
}

function parsePayExpireSeconds(payConfig) {
  const pc = payConfig || {}
  const now = Math.floor(Date.now() / 1000)
  if (pc.expire_time != null) {
    const t = Number(pc.expire_time)
    if (t > 1e12) {
      const diff = Math.floor(t / 1000) - now
      if (diff > 0) return diff
    } else if (t > now) {
      return Math.floor(t - now)
    } else if (t > 0 && t < 86400) {
      return Math.floor(t)
    }
  }
  if (pc.expire_seconds != null) {
    const s = Number(pc.expire_seconds)
    if (s > 0) return Math.floor(s)
  }
  return 15 * 60
}

/**
 * 从下单结果组装支付弹窗数据
 * @param {object} orderRes
 * @param {object} [plan]
 */
export function buildVipPayModalPayload(orderRes, plan) {
  const { root, order: inner, payConfig: pc } = normalizeVipOrderResponse(orderRes)
  const order = inner || root
  const qrCode = pickPayQrCodeString(orderRes) || pc.qr_code || pc.qrcode || ''
  const payMoney =
    centsToYuanDisplay(order.pay_money) ||
    centsToYuanDisplay(order.money_price) ||
    centsToYuanDisplay(root.pay_money) ||
    (plan && plan.priceMain) ||
    '0'
  const priceOld =
    (plan && plan.priceOld) ||
    priceYuanFromYuanField(order.huaxian_money_price) ||
    priceYuanFromYuanField(root.huaxian_money_price) ||
    ''
  const days = (plan && plan.billingDays) || Number(pc.days) || 30
  const periodLabel = days >= 300 ? '连续包年' : '连续包月'
  const titleParts = []
  if (plan && plan.name) titleParts.push(plan.name)
  else if (plan && plan.badge) titleParts.push(plan.badge)
  else titleParts.push('会员套餐')
  if (plan && plan.monthlyCredits && plan.monthlyCredits !== '0') {
    titleParts.push(`${plan.monthlyCredits}积分`)
  }
  titleParts.push(periodLabel)

  let renewNote = pc.renew_tip || pc.renew_note || ''
  if (!renewNote && priceOld) {
    renewNote = `次月按 ¥${priceOld}/月自动续费，可随时取消`
  }

  return {
    orderId: extractVipOrderId(orderRes),
    title: titleParts.join(' '),
    priceMain: payMoney,
    priceOld: priceOld || '',
    discountLabel: (plan && plan.discountChip) || pc.discount_label || '',
    qrCode,
    renewNote,
    expireSeconds: parsePayExpireSeconds(pc)
  }
}

/** 从下单结果解析订单 ID（供 scan_alipay 轮询） */
export function extractVipOrderId(orderRes) {
  const { root, order: inner, payConfig: pc } = normalizeVipOrderResponse(orderRes)
  const pr = root.payment_record || root.paymentRecord || pc.payment_record || {}
  const candidates = [
    pc.order_id,
    inner && inner.id,
    inner && inner.order_id,
    pc.payment_record_id,
    pc.payment_id,
    pc.id,
    pr.id,
    pr.order_id,
    root.order_id,
    root.payment_record_id,
    root.id
  ]
  for (let i = 0; i < candidates.length; i++) {
    const v = candidates[i]
    if (v != null && v !== '') return v
  }
  return null
}

/**
 * 轮询支付宝支付状态 GET /payment-record/scan_alipay?order_id=
 * @param {number|string} orderId
 */
export async function scanAlipayPayment(orderId) {
  if (orderId == null || orderId === '') {
    throw new Error('缺少订单号')
  }
  const res = await api.get('/payment-record/scan_alipay', {
    params: { order_id: orderId }
  })
  return res
}

/** 解析 scan_alipay 是否已支付（常见：data 为 1 / true 表示已支付，0 为未支付） */
export function isAlipayPaymentPaid(res) {
  if (res == null) return false
  const c = res.code
  if (c !== undefined && c !== null) {
    const n = Number(c)
    if (n !== 0 && n !== 200) return false
  }
  const d = res.data
  if (d === 0 || d === false || d === '0' || d === 'unpaid' || d === 'pending') return false
  if (d === 1 || d === true || d === '1' || d === 'paid' || d === 'success') return true
  if (d === 2 || d === '2') return true
  if (typeof d === 'object' && d) {
    const st = d.status != null ? String(d.status).toLowerCase() : ''
    if (st === 'paid' || st === 'success' || st === 'completed') return true
    if (d.paid === 1 || d.paid === true || d.is_paid === 1 || d.is_paid === true) return true
    const ps = Number(d.pay_status)
    if (ps === 1 || ps === 2) return true
  }
  return false
}

export function extractVipPayQrCode(orderRes) {
  const direct = pickPayQrCodeString(orderRes)
  if (direct) return direct
  const { payConfig: pc } = normalizeVipOrderResponse(orderRes)
  return pc.qr_code || pc.qrcode || ''
}

/** 解析下单结果中的支付信息（二维码 / 跳转链接 / 订单号） */
export function resolveVipOrderPayment(orderRes) {
  const qrCode = extractVipPayQrCode(orderRes)
  const payUrl = extractVipOrderPayUrl(orderRes)
  const orderId = extractVipOrderId(orderRes)
  const { root } = normalizeVipOrderResponse(orderRes)
  const payType = root.pay_type || root.payType || ''
  const needPay = root.is_need_pay != null ? Number(root.is_need_pay) : null
  return { qrCode, payUrl, orderId, payType, needPay }
}

export function getVipOrderPaymentFailureMessage(orderRes, fallback = '未获取到支付二维码，请稍后重试') {
  const { needPay, payType } = resolveVipOrderPayment(orderRes)
  if (needPay === 0) return '订单无需支付，请刷新会员状态'
  if (payType === 'select_pending') return '请在 App 内选择支付方式后完成购买'
  const root = orderRes && typeof orderRes === 'object' ? orderRes : {}
  const msg = root.message || root.msg || root.error
  if (typeof msg === 'string' && msg.trim()) return msg.trim()
  return fallback
}

/** 从下单结果中解析收银台 / 支付链接 */
export function extractVipOrderPayUrl(orderRes) {
  const o = orderRes || {}
  const nested = o.pay && typeof o.pay === 'object' ? o.pay : null
  const candidates = [
    o.pay_url,
    o.payment_url,
    o.h5_url,
    o.mweb_url,
    o.cashier_url,
    o.redirect_url,
    o.url,
    nested && nested.url,
    nested && nested.h5_url,
    nested && nested.mweb_url
  ]
  for (let i = 0; i < candidates.length; i++) {
    const u = candidates[i]
    if (typeof u === 'string' && /^https?:\/\//i.test(u)) return u
  }
  return null
}

export function getApiErrorMessage(err, fallback = '请求失败') {
  if (!err) return fallback
  const d = err.response && err.response.data
  if (d && (d.message || d.msg)) return String(d.message || d.msg)
  if (err.message) return err.message
  return fallback
}
